import React from 'react';
import { ProductCardSkeleton } from '@noths/polaris-design-system-candidate-components';

import { PRODUCT_CARD_GRID_ITEM_ID } from 'src/components/organisms/ProductPages/constants/elementIds';
import * as styles from './ProductList/ProductList.styles';

const SKELETON_PRODUCT_LIST_ID = 'skeleton-product-list';
export const SKELETON_PRODUCT_LIST_TEST_ID = 'skeleton-product-list';

const PRODUCTS_PER_PAGE = 60;

export const SkeletonProductList = () => {
  const cards = Array(PRODUCTS_PER_PAGE).fill(null);

  return (
    /* `aria-busy` sits on the grid rather than on the cards because each
       `ProductCardSkeleton` is `aria-hidden`: a placeholder has nothing a screen reader
       can use, and sixty of them announcing themselves would be sixty announcements of
       nothing. The grid says once that its products are on their way. */
    <div
      aria-busy
      css={[styles.productGrid, styles.productListWrapper, styles.fadeIn]}
      data-testid={SKELETON_PRODUCT_LIST_TEST_ID}
      id={SKELETON_PRODUCT_LIST_ID}
    >
      {cards.map((_, index) => {
        return (
          <div
            // eslint-disable-next-line react/no-array-index-key
            css={styles.productCardGridItem}
            id={`${PRODUCT_CARD_GRID_ITEM_ID}-${index}`}
            key={`skeleton-${index}`}
          >
            <ProductCardSkeleton />
          </div>
        );
      })}
    </div>
  );
};
